// third party and libraries 
import React, { useEffect, useState } from 'react';
import { Modal, ListGroup, InputGroup, Form, Card, Row, Col, Button, Table, Spinner } from 'react-bootstrap';
import { useLazyQuery, useMutation } from '@apollo/client';
import moment from 'moment';
import _ from 'lodash';

// icons
import { FaArrowAltCircleRight, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import { IoMdCloseCircle } from 'react-icons/io';
import { MdAdd, MdCheck, MdDelete, MdEdit, MdModeEditOutline } from 'react-icons/md';

// component and constants
import FormDefaultAddress from './FormDefaultAddress';
import { SHOP } from '../../../graphql/shop/queryShop';
import { convertLogicticsName, imageRender } from '../../../helpers';
import ShopMap from './ShopMap';
import { UPDATE_SHOP } from '../../../graphql/shop/mutation';
import { GET_SETTING_BY_SHOP } from '../../../graphql/setting/query';
import { UPDATE_SETTING } from '../../../graphql/setting/mutation';
import { K_LOCAL_STORAGE_SHOP_DATA, K_LOCAL_STORAGE_SHOP_SETTING_DATA, LOGISTICS_DATAS } from '../../../constants';
// import LoadingSpinner from '../../../components/LoadingSpinner';
import { GET_SHOP_ADDRESS_DEFAULT } from '../../../graphql/shop/shopAddress/query';
import { DELETE_SHOP_ADDRESS, UPDATE_DEFAULT_SHOP_ADDRESS } from '../../../graphql/shop/shopAddress/mutation';
import { errorSwal, successSwal } from '../../../helpers/sweetalert';
import LoadingUpdates from '../../../components/LoadingUpdates';

// constants this component
const WHITE_200 = "#f1f1f2";
const COLOR_CONTENT_TEXT = "#776565";
const COLOR_GRAY = "#c0c0c0";

export default function LogisticsPage() {
    // states
    const [isAddModal, setIsAddModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [editMode, setEditMode] = useState({
        nameStatus: false,
        phoneStatus: false,
        usernameStatus: false,
        noteStatus: false,
    });
    const [formShopData, setFormShopData] = useState({
        name: '',
        image: '',
        phone: '',
        paymentMethod: '',
        address: '',
        note: '',
        currentDate: ""
    });
    const [shopName, setShopName] = useState()
    const [phoneNumber, setPhoneNumber] = useState()
    const [remark, setRemark] = useState()
    const [isAddMap, setIsAddMap] = useState(false)
    const [googleMapsLink, setGoogleMapsLink] = useState("");
    const [isGetOrderInShop, setIsGetOrderInShop] = useState({ deliveryOfPoint: false })
    const [shopLogictics, setShopLogictics] = useState()
    const [settingId, settSetingId] = useState()
    const [googleMapEdit, setGoogleMapEdit] = useState()
    const [isCOD, setIsCOD] = useState({
        isOpen: false,
        logisticsCOD: false,
        mxCOD: false,
        ansCOD: false,
    })
    const [isLogictics, setIsLogictics] = useState({
        halIsOpen: false,
        mxIsOpen: false,
        jntIsOpen: false,
        ansIsOpen: false,
    })
    const [notifys, setNotifys] = useState({
        notifyClaimBalance: false,
        notifyPaid: false,
        notifyDlv: false,
        notifyDlvDestination: false,
        notifyComplete: false,
    })
    const [depositorDatas, setDepositorDatas] = useState([])
    const [loadingEdit, setLoadingEdit] = useState(false);


    // useLazyQuery appollo client
    const [getShop, { data: shopData, loading: shopLoading }] = useLazyQuery(SHOP, { fetchPolicy: "cache-and-network" });
    const [getSettingByShop, { data: settingByShop, loading: loadingSettingByShop }] = useLazyQuery(GET_SETTING_BY_SHOP, { fetchPolicy: "cache-and-network" });
    const [getShopAddress, { data: shopAddressDefault, loading: loadingShopAddress }] = useLazyQuery(GET_SHOP_ADDRESS_DEFAULT, { fetchPolicy: "cache-and-network" });

    // useMutation for apollo client
    const [updateShop, { loading: loadingUpdateShop }] = useMutation(UPDATE_SHOP);
    const [updateSettingShop, { loading: loadingUpdateSetting }] = useMutation(UPDATE_SETTING);
    const [deleteShopAddress, { loading: loadingDeleteShopAddress }] = useMutation(DELETE_SHOP_ADDRESS);
    const [updateShopAddressDefault, { loading: loadingEditShopAddress }] = useMutation(UPDATE_DEFAULT_SHOP_ADDRESS);

    // const [createAddressShop, { loading: loadingCreateAddress }] = useMutation(ADD_SETTING_SHOP_ADDRESS);

    // useEffect fetch the data
    useEffect(() => {
        const shop_id = localStorage.getItem("SHOP");
        if (shop_id) {
            getShopData(shop_id);
            fetchSettingByShop(shop_id)
            fetchShopAddressDefault(shop_id)
        }
    }, []);

    // fetch get data then query data
    useEffect(() => {
        if (shopData) {
            setShopName(shopData?.shop?.name)
            setPhoneNumber(shopData?.shop?.phone)
            setRemark(shopData?.shop?.note)
            setFormShopData({
                name: shopData?.shop?.name,
                image: shopData?.shop?.image,
                phone: shopData?.shop?.phone,
                paymentMethod: shopData?.shop?.paymentType === "SUBSCRIPTION" ? "ລາຍເດືອນ" : shopData?.shop?.paymentType === "POINT" ? "ພ້ອຍ" : "ທົດລອງນຳໃຊ້",
                address: shopData?.shop?.address?.province + ", " + shopData?.shop?.address?.district + ", " + shopData?.shop?.address?.village,
                currentDate: moment(shopData?.shop?.startDate).format("DD/MM/YYYY") + " - " + moment(shopData?.shop?.endDate).format("DD/MM/YYYY"),
                note: shopData?.shop?.note,
            })
            localStorage.setItem(K_LOCAL_STORAGE_SHOP_DATA, JSON.stringify(shopData?.shop));
        };
        if (settingByShop) {
            localStorage.setItem(K_LOCAL_STORAGE_SHOP_SETTING_DATA, JSON.stringify(settingByShop?.settingByShopId));

            setShopLogictics(settingByShop?.settingByShopId)
            setGoogleMapsLink(settingByShop?.settingByShopId?.latLong)
            setIsLogictics({
                halIsOpen: settingByShop?.settingByShopId?.halIsOpen,
                mxIsOpen: settingByShop?.settingByShopId?.mxIsOpen,
                jntIsOpen: settingByShop?.settingByShopId?.jntIsOpen,
                ansIsOpen: settingByShop?.settingByShopId?.ansIsOpen,
            })
            setIsCOD({
                logisticsCOD: settingByShop?.settingByShopId?.logisticsCOD,
                mxCOD: settingByShop?.settingByShopId?.mxCOD,
                ansCOD: settingByShop?.settingByShopId?.ansCOD,
            })
            setNotifys({
                notifyClaimBalance: settingByShop?.settingByShopId?.notifyClaimBalance,
                notifyPaid: settingByShop?.settingByShopId?.notifyPaid,
                notifyDlv: settingByShop?.settingByShopId?.notifyDlv,
                notifyDlvDestination: settingByShop?.settingByShopId?.notifyDlvDestination,
            })
            setIsGetOrderInShop({ deliveryOfPoint: settingByShop?.settingByShopId?.deliveryOfPoint })
            settSetingId(settingByShop?.settingByShopId?.id)
        }

    }, [shopData, settingByShop]);

    useEffect(() => {
        if (shopAddressDefault) {
            setDepositorDatas(shopAddressDefault?.shopAddressShopId?.data)
        }
    }, [shopAddressDefault])

    useEffect(() => {
        handleUpdateSettingOnShop()
    }, [googleMapEdit])

    // handle update shop address default
    const handleUpdateShopAddressDefault = async (_data) => {
        try {
            if (loadingEditShopAddress) return;
            await updateShopAddressDefault({
                variables: {
                    where: {
                        shop: _data?.shop,
                        id: _data?.id,
                    },
                    data: {
                        setDefault: true
                    }
                }
            }).then(() => {
                fetchShopAddressDefault(_data?.shop)
            })

        } catch (error) {
            console.error({ error })
        }
    }

    // get shop data
    const getShopData = async (shopId) => {
        await getShop({
            variables: {
                where: {
                    id: shopId,
                },
            },
        });
    };

    // fetch setting on shop
    const fetchSettingByShop = async (shopId) => {
        await getSettingByShop({
            variables: {
                where: {
                    shop: shopId,
                },
            },
        });
    };

    // get shop address
    const fetchShopAddressDefault = async (shopId) => {
        try {
            await getShopAddress({
                variables: {
                    where: {
                        shop: shopId
                    }
                }
            })

        } catch (error) {
            console.log(error)
        }
    }

    // Handle closing the modal
    const onCloseModalAdd = () => setIsAddModal(false);

    // Handle update and exit edit mode
    const handleUpdateShop = async () => {
        const shopId = localStorage.getItem("SHOP");
        if (!shopId) return;
        if (loadingUpdateShop) return;
        try {
            let _data = {}

            if (!_.isEmpty(shopName)) {
                _data = {
                    ..._data,
                    name: shopName
                }
            }
            if (!_.isEmpty(phoneNumber)) {
                _data = {
                    ..._data,
                    phone: phoneNumber
                }
            }
            if (!_.isEmpty(remark)) {
                _data = {
                    ..._data,
                    note: remark
                }
            }

            await updateShop({
                variables: {
                    data: _data,
                    where: {
                        id: shopId,
                    },
                },
            });

            setEditMode({
                nameStatus: false,
                phoneStatus: false,
                usernameStatus: false,
                noteStatus: false,
            })
            getShopData(shopId)
        } catch (error) {
            console.log(error);
        }
    };

    // Handle Save button click (perform actions with selected position)
    const handleUpdateSettingOnShop = async (key, value) => {
        try {
            if (loadingUpdateSetting) return;
            setLoadingEdit(true)

            // Prepare the data with dynamic key/value update
            let _dataEdit = {
                [key]: value,
            };
            if (!_.isEmpty(googleMapEdit)) {
                _dataEdit = {
                    ..._dataEdit,
                    latLong: googleMapEdit
                }
            }
            await updateSettingShop({
                variables: {
                    data: _dataEdit,
                    where: {
                        id: settingId,
                    },
                },
            });

            // Optionally close the map after saving
            onCloseMap();
        } catch (error) {
            console.error("Error updating shop settings:", error);
        }
    };

    // Fuse Update Handler
    const handleFuseChange = (key, value) => {
        // Dynamically update the appropriate fuse in the state
        switch (key) {
            case 'logisticsCOD':
            case 'mxCOD':
            case 'ansCOD':
                setIsCOD((prevState) => ({ ...prevState, [key]: value }));
                break;
            case 'halIsOpen':
            case 'mxIsOpen':
            case 'jntIsOpen':
            case 'ansIsOpen':
                setIsLogictics((prevState) => ({ ...prevState, [key]: value }));
                break;
            case 'notifyClaimBalance':
            case 'notifyPaid':
            case 'notifyDlv':
            case 'notifyDlvDestination':
                setNotifys((prevState) => ({ ...prevState, [key]: value }));
                break;
            case 'deliveryOfPoint':
                setIsGetOrderInShop((prevState) => ({ ...prevState, [key]: value }));
                break;
            default:
                break;
        }

        // Update the shop setting with the new value for the selected fuse
        handleUpdateSettingOnShop(key, value);
    };


    // close add map
    const onCloseMap = () => {
        const _shopId = localStorage.getItem("SHOP");
        setIsAddMap(false)
        setLoadingEdit(false)
        fetchSettingByShop(_shopId)
    }

    const handleDeleteAddress = async (data) => {
        try {
            if (loadingDeleteShopAddress) return;
            await deleteShopAddress({
                variables: {
                    where: {
                        shop: data?.shop,
                        id: data?.id,
                    }
                }
            }).then((res) => {
                if (res) {
                    successSwal("ລົບສຳເລັດແລ້ວ!")
                    fetchShopAddressDefault(data?.shop)
                }
            })

        } catch (error) {
            console.log("error handleDeleteAddress: ",error)
            if (error?.message === "CAN_NOT_DELETE_DELIVERY_HAVE_ORDER") {
                errorSwal("ບໍ່ສາມາດລົບຂົນສົ່ງທີ່ເຊື່ອມກັບອໍເດີໄດ້");
                return;
            }
            errorSwal("ລົບບໍ່ສຳເລັດແລ້ວ");
        }
    }
    const handleEditAddress = async (data) => {
        setIsAddModal(true);
        setEditData(data);
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={4}>
                    <Card style={{ padding: 20, boxShadow: 'none', display: 'flex', justifyContent: 'start', alignItems: 'center', flexDirection: 'column' }}>
                        <img src={imageRender(formShopData?.image)} style={{ width: 170, height: 170, borderRadius: "40em", border: '4px solid #ffffff', margin: '10px 0' }} alt="Shop" />
                        <h2>{formShopData?.name ?? "-"}</h2>
                        <ListGroup style={{ width: '100%' }} as="ul">
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}` }} disabled >ໄລຍະເວລາ: {formShopData?.currentDate}</ListGroup.Item>

                            {/* Name field */}
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', paddingBottom: 0 }}>
                                {editMode.nameStatus ? (
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            placeholder="Enter Shop Name"
                                            aria-label="Shop Name"
                                            value={shopName}
                                            onChange={(e) => setShopName(e?.target?.value)}
                                        />
                                        <InputGroup.Text id="basic-addon2">
                                            {loadingUpdateShop ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                <FaCheckCircle style={{ color: 'green', fontSize: 20, cursor: 'pointer' }} onClick={() => handleUpdateShop()} />
                                            )}
                                            &nbsp;&nbsp;
                                            <IoMdCloseCircle style={{ color: 'red', fontSize: 24, cursor: 'pointer' }} onClick={() => setEditMode((prev) => ({ ...prev, nameStatus: false }))} />
                                        </InputGroup.Text>
                                    </InputGroup>
                                ) : (
                                    <>
                                        <div>
                                            <p>{formShopData?.name ?? "-"}</p>
                                        </div>
                                        <div>
                                            <MdModeEditOutline onClick={() => setEditMode((prev) => ({ ...prev, nameStatus: true }))} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </>
                                )}
                            </ListGroup.Item>

                            {/* Phone field */}
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', paddingBottom: 0 }}>
                                {editMode.phoneStatus ? (
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            placeholder="Enter Phone Number"
                                            aria-label="Phone Number"
                                            value={phoneNumber}
                                            onChange={(e) => {
                                                let _value = e?.target?.value
                                                if (_value?.length > 8) return;
                                                setPhoneNumber(_value)
                                            }}
                                        />
                                        <InputGroup.Text id="basic-addon2">
                                            {loadingUpdateShop ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                <FaCheckCircle style={{ color: 'green', fontSize: 20, cursor: 'pointer' }} onClick={() => handleUpdateShop()} />
                                            )}
                                            &nbsp;&nbsp;
                                            <IoMdCloseCircle style={{ color: 'red', fontSize: 24, cursor: 'pointer' }} onClick={() => setEditMode((prev) => ({ ...prev, phoneStatus: false }))} />
                                        </InputGroup.Text>
                                    </InputGroup>
                                ) : (
                                    <>
                                        <div>
                                            <p>{formShopData?.phone ?? "-"}</p>
                                        </div>
                                        <div>
                                            <MdModeEditOutline onClick={() => setEditMode((prev) => ({ ...prev, phoneStatus: true }))} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </>
                                )}
                            </ListGroup.Item>

                            {/* Username field */}
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', paddingBottom: 0 }}>
                                <div>
                                    <p>{formShopData?.paymentMethod}</p>
                                </div>
                                <div>
                                </div>
                            </ListGroup.Item>

                            {/* Address field */}
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', paddingBottom: 0 }}>
                                <div>
                                    <p>{formShopData?.address ?? "-"}</p>
                                </div>
                                <div>
                                </div>
                            </ListGroup.Item>

                            {/* Note field */}
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', paddingBottom: 0 }}>
                                {editMode.noteStatus ? (
                                    <InputGroup className="mb-3">
                                        <Form.Control
                                            placeholder="Enter Note"
                                            aria-label="Note"
                                            value={remark}
                                            onChange={(e) => setRemark(e?.target?.value)}
                                        />
                                        <InputGroup.Text id="basic-addon2">
                                            {loadingUpdateShop ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                <FaCheckCircle style={{ color: 'green', fontSize: 20, cursor: 'pointer' }} onClick={() => handleUpdateShop()} />
                                            )}
                                            &nbsp;&nbsp;
                                            <IoMdCloseCircle style={{ color: 'red', fontSize: 24, cursor: 'pointer' }} onClick={() => setEditMode((prev) => ({ ...prev, noteStatus: false }))} />
                                        </InputGroup.Text>
                                    </InputGroup>
                                ) : (
                                    <>
                                        <div>
                                            <p>{formShopData.note}</p>
                                        </div>
                                        <div>
                                            <MdModeEditOutline onClick={() => setEditMode((prev) => ({ ...prev, noteStatus: true }))} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </>
                                )}
                            </ListGroup.Item>
                        </ListGroup>
                    </Card>
                </Col>
                <Col>
                    <Card style={{ boxShadow: 'none', padding: 10 }}>
                        <Card.Header style={{ fontWeight: 'bold', fontSize: 20 }}>1. ລາຍການຕັ້ງຄ່າກ່ຽວກັບຂົນສົ່ງ</Card.Header>
                        <ListGroup variant="flush"    >
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div>
                                    <p style={{ fontSize: 18 }}><FaArrowAltCircleRight style={{ color: COLOR_GRAY }} /> ມີຮັບເຄື່ອງໜ້າຮ້ານ</p>

                                    <div style={{ opacity: !isGetOrderInShop?.deliveryOfPoint ? 0.6 : 1, marginLeft: 10, color: COLOR_CONTENT_TEXT }} >
                                        {/* <IoIosAddCircleOutline onClick={() => { isGetOrderInShop?.deliveryOfPoint ? setIsAddMap(true) : setIsAddMap(false) }} style={{ fontSize: 20, cursor: 'pointer', color: 'green' }} /> */}
                                        <Button size="sm" variant='outline-info' disabled={!isGetOrderInShop?.deliveryOfPoint ? true : false} onClick={() => setIsAddMap(true)}>
                                            {googleMapsLink ? (
                                                <>
                                                    <MdModeEditOutline /> ແກ້ໄຂ
                                                </>
                                            ) : (
                                                <>
                                                    <MdAdd /> ເພິ່ມ
                                                </>
                                            )}
                                        </Button>
                                        <p style={{ fontSize: 14 }}>Google maps:{" "}
                                            {isGetOrderInShop?.deliveryOfPoint ?
                                                <a style={{ fontSize: 12, }} href={googleMapsLink} target="_blank" rel="noopener noreferrer">
                                                    {googleMapsLink}
                                                </a> : <small>{googleMapsLink}</small>}
                                        </p>
                                    </div>
                                </div>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    size="lg"
                                    style={{ marginTop: '-1em', }}
                                    checked={isGetOrderInShop?.deliveryOfPoint}
                                    onChange={(e) => handleFuseChange('deliveryOfPoint', e?.target?.checked)}
                                />

                            </ListGroup.Item>
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div>
                                    <p style={{ fontSize: 18 }}><FaArrowAltCircleRight style={{ color: COLOR_GRAY }} /> ເກັບຄ່າເຄື່ອງປາຍທາງ (COD)</p>
                                    <div style={{ paddingBottom: 10, display: 'flex', gap: 20, marginLeft: 20, color: COLOR_CONTENT_TEXT }}>
                                        <Form.Check
                                            type="checkbox"
                                            label={isCOD?.logisticsCOD ? "ເປີດ" : "ປີດ"}
                                            id="checked-default-hal"
                                            style={{ scale: 1.3 }}
                                            checked={isCOD?.logisticsCOD}
                                            onChange={(e) => handleFuseChange('logisticsCOD', e?.target?.checked)}

                                        />
                                        
                                    </div>
                                </div>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <p style={{ width: '100%', paddingBottom: 0, color: 'orange', marginLeft: 20 }}>
                                    <p><FaInfoCircle style={{ fontSize: 25, paddingRight: 5, color: 'orange' }} /><b>ໝາຍເຫດ:</b> ຮ້ານຕ້ອງສະໝັກ COD ນຳຂົນສົ່ງກ່ອນ!</p>
                                </p>
                            </ListGroup.Item>
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div>
                                    <p style={{ fontSize: 18 }}><FaArrowAltCircleRight style={{ color: COLOR_GRAY }} /> ເລືອກນຳໃຊ້ຂົນສົ່ງ</p>
                                </div>
                                <div />
                            </ListGroup.Item>
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div className='d-flex justify-content-center ailign-items-center gap-2' style={{ marginLeft: 10 }}>
                                    <img style={{ width: 30, height: 30, marginRight: 10, borderRadius: '40em' }} src={LOGISTICS_DATAS?.hal?.image} alt={LOGISTICS_DATAS?.hal?.keyDefault} />
                                    <p style={{ fontSize: 18, color: COLOR_CONTENT_TEXT }}>{LOGISTICS_DATAS?.hal?.name}</p>
                                </div>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    size="lg"
                                    style={{ marginTop: '-1em', }}
                                    checked={isLogictics?.halIsOpen}
                                    onChange={(e) => handleFuseChange('halIsOpen', e?.target?.checked)}
                                />
                            </ListGroup.Item>
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div className='d-flex justify-content-center ailign-items-center gap-2' style={{ marginLeft: 10 }}>
                                    <img style={{ width: 30, height: 30, marginRight: 10, borderRadius: '40em' }} src={LOGISTICS_DATAS?.mixay?.image} alt={LOGISTICS_DATAS?.mixay?.keyDefault} />
                                    <p style={{ fontSize: 18, color: COLOR_CONTENT_TEXT }}>{LOGISTICS_DATAS?.mixay?.name}</p>
                                </div>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    size="lg"
                                    style={{ marginTop: '-1em', }}
                                    checked={isLogictics?.mxIsOpen}
                                    onChange={(e) => handleFuseChange('mxIsOpen', e?.target?.checked)}
                                />
                            </ListGroup.Item>
                            <ListGroup.Item style={{ border: `1px solid ${WHITE_200}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 0 }}>
                                <div className='d-flex justify-content-center ailign-items-center gap-2' style={{ marginLeft: 10 }}>
                                    <img style={{ width: 30, height: 30, marginRight: 10, borderRadius: '40em' }} src={LOGISTICS_DATAS?.jnt?.image} alt={LOGISTICS_DATAS?.jnt?.keyDefault} />
                                    <p style={{ fontSize: 18, color: COLOR_CONTENT_TEXT }}>{LOGISTICS_DATAS?.jnt?.name}</p>
                                </div>
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    size="lg"
                                    style={{ marginTop: '-1em', }}
                                    checked={isLogictics?.jntIsOpen}
                                    onChange={(e) => handleFuseChange('jntIsOpen', e?.target?.checked)}
                                />
                            </ListGroup.Item>
                        </ListGroup>
                        <Card.Header style={{ fontWeight: 'bold', fontSize: 20, display: 'flex', justifyContent: 'space-between' }}>
                            2. ຂໍ້ມູນຜູ້ຝາກຂອງຮ້ານ 
                            <Button 
                                disabled={(isLogictics?.mxIsOpen || isLogictics?.halIsOpen || isLogictics?.jntIsOpen) ? false : true}
                                onClick={() => setIsAddModal(true)} size='sm' variant='info'
                            >
                                <MdAdd /> ເພິ່ມ
                            </Button> 
                        </Card.Header>

                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                <th>ຂົນສົ່ງດ່ວນ</th>
                                <th>ຂໍ້ມູນ</th>
                                <th>ຄ່າເລິ່ມຕົ້ນ</th>
                                <th>ຈັດການ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {depositorDatas.map((data, index) => (
                                <tr key={index} style={{ backgroundColor: (data?.deliveryName === "MIXAY" && !data?.dropship_end) ? "red" : "white" }}>
                                    <td style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {deliveryImage(data?.deliveryName)}
                                        {/* {convertLogicticsName(data?.deliveryName)} ຂົນສົ່ງດ່ວນ */}
                                    </td>
                                    <td>
                                        <div>ຜູ້ຝາກ: {data?.fullName}</div>
                                        <div>ເບີໂທ: {data?.shopTel}</div>
                                        <div>ລະຫັດ COD: {data?.codNumber}</div>
                                        <div>ແຂວງ: {data?.province}, ເມືອງ: {data?.district}, ສາຂາ: {data?.branch}</div>
                                    </td>
                                    <td>{data?.setDefault ? "✓" : ""}</td>
                                    <td>
                                    <div className='d-flex gap-2'>
                                        <Button size='sm' variant='light' onClick={() => handleDeleteAddress(data)}>
                                            <MdDelete />
                                        </Button>
                                        <Button 
                                            size='sm' 
                                            onClick={() => handleUpdateShopAddressDefault(data)} 
                                            variant={data?.setDefault ? "success" : 'light'}
                                        >
                                            <MdCheck />
                                        </Button>
                                        <Button 
                                            size='sm' 
                                            onClick={() => handleEditAddress(data)}
                                        >
                                            <MdEdit />
                                        </Button> 
                                    </div>
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            </Table>
                                            

                    </Card>
                </Col>
            </Row>

            <Modal centered show={isAddModal} 
            // onHide={onCloseModalAdd}
            >
                <Modal.Header>
                    <Modal.Title>{editData?.id ? "ແກ້ໄຂຂໍ້ມູນຜູ້ຝາກ" : "ເພິ່ມຂໍ້ມູນຜູ້ຝາກ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormDefaultAddress editData={editData} setEditData={setEditData} onCloseModalAdd={onCloseModalAdd} fetchShopAddressDefault={fetchShopAddressDefault} isLogistics={isLogictics} />
                </Modal.Body>
            </Modal>

            <ShopMap isAddMap={isAddMap} onCloseMap={onCloseMap} loadingUpdateSetting={loadingUpdateSetting} setGoogleMapEdit={setGoogleMapEdit} />

            <LoadingUpdates loading={loadingSettingByShop} title="ກຳລັງອັບເດດ..." openLoading={loadingEdit} />

        </React.Fragment>
    );
}

const deliveryImage = (deliveryName) => {
    const imageSrc =
        deliveryName === "HAL" ? LOGISTICS_DATAS.hal.image
        : deliveryName === "JNT" ? LOGISTICS_DATAS.jnt.image
        : LOGISTICS_DATAS.mixay.image;
    return (
        <img
            src={imageSrc}
            alt={deliveryName}
            style={{
            width: 40,
            height: 40,
            marginRight: 10,
            borderRadius: '50%',
            }}
        />
    );
};